import config from '@/config'

import sound from '@/services/sound'

const resetUserPreferences = (state) => {
  state.stateVersion = config.stateVersion
  state.crtFlicker = false
  state.globalVolume = config.maxGlobalVolume
  state.longTextScrollingDuration = true

  return state
}

export default {

  state: resetUserPreferences({}),

  getters: {

    crtFlicker (state) {
      return state.crtFlicker
    },

    longTextScrollingDuration (state) {
      return state.longTextScrollingDuration
    },

    globalVolume (state) {
      return state.globalVolume
    },

    globalVolumeIsAtMin (state, { globalVolume }) {
      return globalVolume <= 0
    },

    globalVolumeIsAtMax (state, { globalVolume }) {
      return globalVolume >= config.maxGlobalVolume
    },

    // FIXME: make this scale logarithmic
    globalVolumeMultiplier (state, { globalVolume }) {
      return globalVolume / config.maxGlobalVolume
    },

    textScrollingDurationMultiplier (state, { longTextScrollingDuration }) {
      return longTextScrollingDuration ? 5 : 0.25
    }

  },

  mutations: {

    resetUserPreferences,

    setCrtFlicker (state, value) {
      state.crtFlicker = !!value
    },

    setGlobalVolume (state, numberValue) {
      state.globalVolume = Math.min(Math.max(numberValue, 0), config.maxGlobalVolume)
    },

    setLongTextScrollingDuration (state, value) {
      state.longTextScrollingDuration = !!value
    }

  },

  actions: {

    toggleCrtFlicker ({ commit, getters }) {
      commit('setCrtFlicker', !getters.crtFlicker)
    },

    async turnGlobalVolumeDown ({ commit, getters }) {
      if (!getters.globalVolumeIsAtMin) {
        const newVolume = getters.globalVolume - 1
        commit('setGlobalVolume', newVolume)
        sound.resetAllPlayers()
        return newVolume
      }

      return true
    },

    async turnGlobalVolumeUp ({ commit, getters }) {
      if (!getters.globalVolumeIsAtMax) {
        const newVolume = getters.globalVolume + 1
        commit('setGlobalVolume', newVolume)
        sound.resetAllPlayers()
        return newVolume
      }

      return getters.globalVolume
    },

    toggleTextScrollingDuration ({ commit, getters }) {
      commit('setLongTextScrollingDuration', !getters.longTextScrollingDuration)
    }

  }

}
